import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicesPage from './pages/Service/servicesPage';
import SponsorPage from './pages/Sponsor/sponsorsPage'
import EditServicePage from './pages/Service/EditServicePage';
import AddServicePage from './pages/Service/AddServicePage'
import LoginPage from './pages/loginPage'
import { Routes, Route } from 'react-router-dom'
import { GlobalContext } from './context/store';

function App() {

// must declare values being passed into provider
  const [token, setToken] = useState('');
  const [editId, setEditId] = useState('');
  const [orgId, setOrgId] = useState('')

  

  return (
    <>


      <GlobalContext.Provider value={{ token, setToken, editId, setEditId, orgId, setOrgId}}>
        <Routes>

          <Route path="/" element={<LoginPage />} />
          <Route path="main" element={<ServicesPage />} />
          <Route path="addService" element={<AddServicePage />} />
          <Route path="editService" element={<EditServicePage />} />
          <Route path='sponsor' element={<SponsorPage />} />

        </Routes>

      </GlobalContext.Provider>




    </>
  );
}

export default App;
